export const SET_AUTH = 'SET_AUTH';
export const LOG_OUT = 'LOG_OUT';
export const SET_USER = 'SET_USER';
export const SET_WALLET = 'SET_WALLET';
export const SET_RATES = 'SET_RATES';
export const SET_ORDER_BOOK = 'SET_ORDER_BOOK';
export const SET_MODAL_STATES = 'SET_MODAL_STATES';
